import React from 'react';
import { ClipboardText } from '@phosphor-icons/react';
import {
  DueDiligenceQuestion,
  DueDiligenceResponse,
} from 'shared/types/due-diligence';
import DueDiligenceQuestionItem from './DueDiligenceQuestionItem';

interface ResponseState {
  questionId: number;
  selectedOptionId: number | null;
  notes: string;
  freeTextAnswer?: string | null;
  numberAnswer?: number | null;
  dateAnswer?: string | null;
  booleanAnswer?: boolean | null;
}

interface DueDiligenceQuestionListProps {
  questions: DueDiligenceQuestion[];
  responses: DueDiligenceResponse[];
  responseStates: ResponseState[];
  onResponseChange: (questionId: number, updates: Partial<ResponseState>) => void;
  getUserName: (userId: string | undefined) => string | null;
  buildingId?: string;
  unitId?: string;
}

/**
 * Container component for rendering a list of DD questions.
 * Sorts by displayOrder and filters to active questions.
 */
const DueDiligenceQuestionList: React.FC<DueDiligenceQuestionListProps> = ({
  questions,
  responses,
  responseStates,
  onResponseChange,
  getUserName,
  buildingId,
  unitId,
}) => {
  // Filter to active questions and sort by displayOrder
  const sortedQuestions = [...questions]
    .filter(q => q.active)
    .sort((a, b) => a.displayOrder - b.displayOrder);

  if (sortedQuestions.length === 0) {
    return (
      <div className="text-center py-8 text-neutral-secondary-mid">
        <ClipboardText weight="duotone" size={48} className="mx-auto mb-2 opacity-50" />
        <p>Geen actieve vragen in deze categorie</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <h2 className="text-sm font-semibold text-gray-700 flex items-center gap-2">
        <ClipboardText weight="duotone" size={18} />
        Vragen ({sortedQuestions.length})
      </h2>

      <div className="space-y-4">
        {sortedQuestions.map((question) => {
          const responseState = responseStates.find(r => r.questionId === question.id);
          const existingResponse = responses.find(r => r.questionId === question.id);

          return (
            <DueDiligenceQuestionItem
              key={question.id}
              question={question}
              responseState={responseState}
              existingResponse={existingResponse}
              onResponseChange={onResponseChange}
              getUserName={getUserName}
              buildingId={buildingId}
              unitId={unitId}
            />
          );
        })}
      </div>
    </div>
  );
};

export default DueDiligenceQuestionList;
